import React from 'react';
import { QUIZ_TYPES } from '../../constants/Quiz';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  EditButton,
  NumberInput,
  FileField,
  FileInput,
  ImageField,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  BooleanField,
  BooleanInput,
  Filter,
  ArrayField,
  SingleFieldList,
  ChipField,
  required,
} from 'react-admin';

const TextFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ID" source="id" alwaysOn />
    <SelectInput
      label="Төрөл"
      source="type"
      emptyText="Бүгд"
      choices={QUIZ_TYPES}
      alwaysOn
    />
    <ReferenceInput label="Хэл" source="lang" reference="languages" alwaysOn>
      <SelectInput optionText="name" optionValue="id" emptyText="Бүгд" />
    </ReferenceInput>
    <ReferenceInput label="Түвшин" source="lvl" reference="languageLevels" fullWidth alwaysOn>
      <SelectInput optionText="level" optionValue="id" emptyText="Бүгд" />
    </ReferenceInput>
  </Filter>
);

export const LingoQuizList = (props) => (
  <List {...props} filters={<TextFilter/>} >
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <TextField label="Төрөл" source="type" />
      <TextField label="Гарчиг" source="title" />
      <TextField label="Хэл" source="Languages.0.code" sortable={false} />
      <ArrayField label="Түвшин" source="LanguageLevels" sortable={false}>
        <SingleFieldList linkType={false}>
          <ChipField source="level" />
        </SingleFieldList>
      </ArrayField>
      <TextField label="Асуултын тоо" source="numberOfQuestion" />
      <BooleanField label="Үнэгүй үзэх" source="isPreview"/>
      <EditButton />
    </Datagrid>
  </List>
);

const LingoQuizTitle = ({ record }) => {
  return (
    <span>
      Lingo Quiz
      {record ? `"${record.title}"` : ''}
    </span>
  );
};

export const LingoQuizEdit = (props) => (
  <Edit title={<LingoQuizTitle />} {...props} transform={({ thumbnailImage, ...data }) => data}>
    <SimpleForm>
      <TextInput source="id" readOnly />
      <SelectInput source="type" choices={QUIZ_TYPES} />
      <BooleanInput label="Үнэгүй үзэж болох эсэх" source="isPreview" />
      <TextInput fullWidth label="Гарчиг" source="title" />
      <ReferenceInput label="Хэл" source="tagging.languageId" reference="languages">
        <SelectInput source="tagging.languageId" optionText="name" validate={[required()]} />
      </ReferenceInput>
      <ReferenceInput label="Хэлний түвшин" source="tagging.languageLevels.0" reference="languageLevels">
        <SelectInput source="tagging.languageLevels.0" optionText="level" validate={[required()]} />
      </ReferenceInput>
      <NumberInput label="Асуултын тоо" source="numberOfQuestion" />
      <SelectInput source="questionsThrough" label="Асуулт холбох" choices={[{id: 'tags', name: 'Хэл болон түвшингээр'}, {id:'quizId', name:'Тестийн ID-гаар'}]} helperText="Хэрвээ quizId-гаар татах бол харгалзал асуултууд орсон эсэхийг шалгаарай!" />
      <ArrayInput fullWidth source="instructions">
        <SimpleFormIterator>
          <TextInput source="" fullWidth label="Заавар" />
        </SimpleFormIterator>
      </ArrayInput>
      <ImageField source="thumbnailImage" title="Зураг" />
      <FileInput source="file" label="Зураг" accept="image/*">
        <FileField source="image" title="image" />
      </FileInput>
    </SimpleForm>
  </Edit>
);

export const LingoQuizCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <SelectInput source="type" choices={QUIZ_TYPES} validate={[required()]}/>
      <BooleanInput label="Үнэгүй үзэж болох эсэх" initialValue={true} source="isPreview" />
      <TextInput fullWidth label="Гарчиг" source="title" />
      <ReferenceInput label="Хэл" source="tagging.languageId" reference="languages">
        <SelectInput source="tagging.languageId" optionText="name" validate={[required()]} />
      </ReferenceInput>
      <ReferenceInput label="Хэлний түвшин" source="tagging.languageLevels" reference="languageLevels">
        <SelectInput source="tagging.languageLevels" optionText="level" validate={[required()]} />
      </ReferenceInput>
      <NumberInput initialValue={10} label="Асуултын тоо" source="numberOfQuestion" validate={[required()]} />
      <SelectInput source="questionsThrough" label="Асуулт холбох" choices={[{id: 'tags', name: 'Хэл болон түвшингээр'}, {id:'quizId', name:'Тестийн ID-гаар'}]} helperText="Хэрвээ quizId-гаар татах бол харгалзал асуултууд орсон эсэхийг шалгаарай!" />
      <ArrayInput fullWidth source="instructions">
        <SimpleFormIterator>
          <TextInput source="" fullWidth label="Заавар" />
        </SimpleFormIterator>
      </ArrayInput>
      <FileInput source="file" label="Зураг" accept="image/*">
        <FileField source="image" title="image" />
      </FileInput>
    </SimpleForm>
  </Create>
);
